import { Status, Priority, Horizon, TaskType, MessageStatus } from '@/types/enums'
import type { FilterOption } from '@/types/filters'

/**
 * Common filter option configurations that can be reused across different filter components
 */

// Status options
export const STATUS_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Statuses' },
  { value: Status.Draft, label: Status.Draft },
  { value: Status.ToDo, label: Status.ToDo },
  { value: Status.InProgress, label: Status.InProgress },
  { value: Status.Done, label: Status.Done },
]

// Priority options (using SelectPriority component)
export const PRIORITY_FILTER_CONFIG = {
  key: 'priority' as const,
  label: 'Priority',
  options: [
    { value: 'all', label: 'All Priorities' },
    { value: Priority.Low, label: Priority.Low },
    { value: Priority.Medium, label: Priority.Medium },
    { value: Priority.High, label: Priority.High },
  ],
}

// Horizon options (using SelectHorizon component)
export const HORIZON_FILTER_CONFIG = {
  key: 'horizon' as const,
  label: 'Horizon',
  options: [
    { value: 'all', label: 'All Horizons' },
    { value: Horizon.None, label: Horizon.None },
    { value: Horizon.Now, label: Horizon.Now },
    { value: Horizon.Next, label: Horizon.Next },
    { value: Horizon.Someday, label: Horizon.Someday },
    { value: Horizon.Never, label: Horizon.Never },
  ],
}

// Task type options
export const TASK_TYPE_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Types' },
  { value: TaskType.Task, label: TaskType.Task },
  { value: TaskType.Milestone, label: TaskType.Milestone },
  { value: TaskType.Approval, label: TaskType.Approval },
]

// Date range options
export const DATE_RANGE_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Dates' },
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'older', label: 'Earlier' },
]

// Boolean filter options
export const BOOLEAN_FILTER_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
]

// Due date specific options
export const DUE_DATE_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Dates' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'today', label: 'Due Today' },
  { value: 'week', label: 'Due This Week' },
  { value: 'month', label: 'Due This Month' },
  { value: 'no-date', label: 'No Due Date' },
]

// Dependency filter options
export const DEPENDENCY_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Tasks' },
  { value: 'yes', label: 'Is a Dependency' },
  { value: 'no', label: 'Not a Dependency' },
]

// Message status options
export const MESSAGE_STATUS_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Statuses' },
  { value: MessageStatus.Draft, label: MessageStatus.Draft },
  { value: MessageStatus.Published, label: MessageStatus.Published },
  { value: MessageStatus.Archived, label: MessageStatus.Archived },
  { value: MessageStatus.Deleted, label: MessageStatus.Deleted },
]

// Read status options for messages
export const READ_STATUS_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Messages' },
  { value: 'read', label: 'Read' },
  { value: 'unread', label: 'Unread' },
]
